import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Component } from 'react';
import ActivationErrorModal from 'ui-addon-upgrades/_core/common/components/activation/ActivationErrorModal';
import ActivationSuccessModal from './ActivationSuccessModal';
import { upgradeDataPropsInterface } from '../../data/upgradeData/interfaces/upgradeDataPropsInterface';

class ActivationModalContainer extends Component {
  constructor(props) {
    super(props);
    this.handleModalClose = this.handleModalClose.bind(this);
  }

  handleModalClose() {
    const {
      onSuccess = () => {}
    } = this.props;
    onSuccess();
  }

  render() {
    const {
      hasError = false,
      type,
      upgradeData
    } = this.props;

    if (hasError) {
      return /*#__PURE__*/_jsx(ActivationErrorModal, {});
    }

    return /*#__PURE__*/_jsx(ActivationSuccessModal, {
      type: type,
      onSuccess: this.handleModalClose,
      upgradeData: upgradeData
    });
  }

}

ActivationModalContainer.defaultProps = {
  shouldHideSurvey: false
}; //@ts-expect-error propTypes typing is too long

ActivationModalContainer.propTypes = Object.assign({
  hasError: PropTypes.bool.isRequired,
  type: PropTypes.string.isRequired,
  onSuccess: PropTypes.func
}, upgradeDataPropsInterface);
export default ActivationModalContainer;